<template>
    <div class="portrait-alert-main">
      <!-- <transition name="opacity">
        <div class="cover" v-if="alertData.show && alertData.type === 'upimg'" @click="close"></div>
      </transition> -->
      <transition name="alert">
        <div class="box" v-if="alertData.show && alertData.type === 'upimg'">
          <div class="title">添加头像</div>
          <div class="option">
            <div :class="[type === 1 ? 'active' : '']">1.选择图片</div>
            <div :class="[type === 2 ? 'active' : '']">2.剪裁图片</div>
          </div>
          <div v-show="type === 1">
            <div class="line"></div>
            <div class="up width-359">
              <input type="file" class="up-input" ref="upInput" accept="image/*" @change="upInputChange">
              <div class="up-btn" @click="upButton">本地上传</div>
              <div class="up-msg">（最大不超过 2 M）</div>
            </div>
            <div class="line"></div>
            <div class="collapse width-359" v-show="alertData.show">
              <el-collapse @change="collapseChange" :accordion="true" v-model="optionValue">
                <el-collapse-item :title="item.title" :name="index" v-for="(item, index) in alertData.avatar_faqs" :key="index">
                  <div v-html="item.description"></div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          <div v-show="type === 2">
            <div class="up-box width-359">
              <vueCropper style="background: transparent;" ref="cropper" :img="option.img"
                :canMove="option.canMove"
                :autoCrop="option.autoCrop"
                :centerBox="option.centerBox"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"></vueCropper>
            </div>
            <div class="width-359 up-box-btn">
              <button @click="prev">上一步</button>
              <button class="active" @click="upload">完成</button>
            </div>
          </div>
        </div>
      </transition>
    </div>
</template>
<script>
import {mapState} from 'vuex';
import { routerTo, dealSignatrue } from '@/assets/js/util';
// if (process.client) {
  var { VueCropper } = require('vue-cropper')
  // var scroll = require('@/components/global/scroll')
  // console.log(scroll, 'scroll')
// }
const option = {
  img: '',
  canMove: true,
  autoCrop: true,
  centerBox: true,
  fixed: true,
  fixedNumber: [80, 96]
}
export default {
  name: 'message',
  components: {
    VueCropper
  },
  data() {
    return {
      optionValue: 2,
      type: 1,
      option,
      fileType:'',
    };
  },
  computed: {
    ...mapState('app', ['alertData']),
    ...mapState('cvs', ['cvs', 'cv', 'cvPages', 'downloadCv', 'editorCvToken'])
  },
  watch: {
    'alertData.show': {
      keep: true,
      immediate: true,
      handler: function (show) {
        if (!show) {
          document.body.style.position = 'initial'
          document.body.style.overflow = 'initial'
        }else{
          document.body.style.position = 'static'
          document.body.style.overflow = 'hidden'
        }
        if (process.client) {
          this.option = option;
          this.$nextTick(async () => {
            this.type = 1;
            if (document.querySelectorAll('.iconfont.iconxiala')) {
              return false;
            }
            let dom = document.querySelectorAll('.portrait-alert-main .el-collapse-item__header');
            for (let i = 0; i < dom.length; i++) {
              let d = document.createElement('i');
              d.classList.add('iconfont', 'iconxiala');
              dom[i].appendChild(d);
            }
          })
        }
      }
    }
  },
  mounted() {
    let dom = document.querySelectorAll('.portrait-alert-main .el-collapse-item__header');
    for (let i = 0; i < dom.length; i++) {
      let d = document.createElement('i');
      d.classList.add('iconfont', 'iconxiala');
      dom[i].appendChild(d);
    }
  },
  methods: {
    // 上传
    async upload() {
      this.$refs.cropper.getCropData(async file => {
        this.option.img = '';
        this.alertData.confirm && this.alertData.confirm(this.close, file, this.fileType);
        this.fileType = '';
      })
    },
    prev() {
      this.type = 1;
      this.$refs.upInput.value = '';
    },
    upButton() {
      this.$refs.upInput.click();
    },
    upInputChange(data) {
      this.option.img = ''
      this.type = 2;
      let file = this.$refs.upInput.files;
      const reader = new FileReader()
      reader.readAsDataURL(file[0])
      this.fileType = file[0].type.split('/')[1];
      reader.onload = e => {
        this.option.img = e.currentTarget.result
        // this.currentIndex = 1
      }
    },
    collapseChange() {
      let dom = document.querySelectorAll('.portrait-alert-main .el-collapse-item__arrow');
      for (let i = 0; i < dom.length; i++) {
        dom[i].classList.remove('el-icon-arrow-right');
        dom[i].classList.add('iconfont', 'iconxiala')
      }
    },
    close() {
      this.$store.dispatch('app/setAlertDataShow', false);
    },
    cancel() {
      this.alertData.cancel && this.alertData.cancel(this.close);
      // this.close();
    },
    confirm() {
      this.alertData.confirm && this.alertData.confirm(this.close, this.value);
    },
    inputChange(value) {
      if (!this.alertData.inputData || !this.alertData.inputData.length)
        return false;
      this.value = String(this.value).substr(0, +this.alertData.inputData.length);
    }
  }
}
</script>
<style lang="scss" scoped>
  .portrait-alert-main {
    width: 0;
    height: 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    .cover {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
      position: fixed;
      top: 0;
      left: 0;
    }
    .box {
      width: 560px;
      min-height: 200px;
      max-height: 825px;
      background: #fff;
      border-radius: 12px;
      position: fixed;
      top: 60px;
      left: 50%;
      transform: translateX(-50%);
      box-sizing: border-box;
      padding: 32px 24px;
      .title {
        font-size: 16px;
        color: #404040;
        margin-bottom: 24px;
        text-align: center;
      }
      .line {
        width: 100%;
        border-bottom: 1px solid #F4F4F4;
      }
      .option {
        display: flex;
        justify-content: center;
        align-items: center;
        &>div {
          color: #9C9C9C;
          font-size: 14px;
          padding-bottom: 14px;
          &:first-child {
            margin-right: 180px;
          }
          &.active {
            color: #404040;
            position: relative;
            &::after {
              content: "";
              display: block;
              width: 36px;
              height: 2px;
              background: #FF4F4C;
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translateX(-50%);
            }
          }
        }
      }
      .width-359 {
        width: 359px;
        margin: auto;
      }
      .up {
        height: 83px;
        display: flex;
        align-items: center;
        .up-btn {
          width: 120px;
          height: 32px;
          background:rgba(255,79,76,1);
          border-radius:2px;
          text-align: center;
          line-height: 32px;
          color: #fff;
          cursor: pointer;
        }
        .up-msg {
          color: #404040;
          font-size: 14px;
        }
        .up-input {
          width: 0;
          height: 0;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
        }
      }
      .up-box {
        // min-height: 300px;
        margin-top: 20px;
        width: 320px;
        height: 320px;
        img {
          max-width: 320px;
          max-height: 320px;
        }
      }
      .up-box-btn {
        margin-top: 20px;
        width: 400px;
        display: flex;
        justify-content: space-between;
        button {
          width: 150px;
          height: 40px;
          font-size: 14px;
          border: 1px solid #D9D9D9;
          color: #606060;
          &.active {
            background: #FF4F4C;
            border-color: #FF4F4C;
            color: #fff;
          }
        }
      }

    }
  }
</style>
<style lang="scss">
  .portrait-alert-main {
    .collapse {
      img {
        max-width: 100%;
      }
    }
    .el-collapse,
    .el-collapse-item__wrap,
    .el-collapse-item__header {
      border: none;
    }
    .el-collapse-item__arrow {
      display: none;
    }
    .el-collapse-item__header {
      justify-content: space-between;
      &.is-active {
        .iconfont {
          transform-origin: 50% 50%;
          transform: rotate(180deg);
        }
      }
    }
    .el-collapse {
      .iconfont {
        color: #9C9C9C;
        font-size: 10px;
        transition: all .3s ease;
      }
    }
    .cropper-box {
      background: #000;
    }
  }
</style>
